<script>
  import { createClickUpTask } from '../clickupApi';
  import { currentUser } from '../stores';
  import { notifications } from '@shopboxai/sb-portal-components';

  let list_id;
  let subject;
  let message;
  const submitRequest = async () => {
    // if (!subject || !message || !list_id) {
    //   notifications.danger('Please fill in all required fields', 1000);
    //   return;
    // }
    try {
      let task_name = `${$currentUser.clientName} - ${subject}`;
      let res = await createClickUpTask(task_name, message, list_id, $currentUser.email);
      console.log(res);
      notifications.success('Request sent', 2000);
    } catch (error) {
      notifications.danger(`${error}`, 2000);
    }
  };
</script>

<form action="" on:submit|preventDefault={submitRequest}>
  <div>
    <label for="request-form-email">Email</label>
    <input type="email" value={$currentUser.email} disabled id="request-form-email" />
  </div>
  <div>
    <label for="request-form-client">Client</label>
    <input type="text" value={$currentUser.clientName} disabled id="request-form-client" />
  </div>

  <div>
    <label for="request-form-help-type">Request type</label>

    <select name="help_type" bind:value={list_id} id="request-form-help-type">
      <option value="205729525">Feature</option>
      <option value="193719349">Issue / Bug</option>
      <option value="193719437">Other</option>
    </select>
  </div>

  <div>
    <label for="request-form-subject">Subject *</label>

    <input type="text" required bind:value={subject} id="request-form-subject" />
  </div>

  <div>
    <label for="request-form-message">Message *</label>
    <br />
    <textarea rows="7" cols="30" required bind:value={message} id="request-form-message" />
  </div>
  <button class="primary">Submit</button>
</form>

<style>textarea{resize:none}form{align-items:flex-start;display:flex;flex-direction:column;justify-content:space-between;margin-bottom:1.5em}form,form>div{width:100%}label{color:var(--t-c);display:inline-block}#request-form-help-type,input,textarea{border:2px solid var(--brd-l);border-radius:5px;color:var(--t-c-lx);display:block;font-size:15px;line-height:1.5;margin-bottom:1em;padding:16px 20px;width:100%}</style>
